import React from 'react';
import { useWizard, WizardSubStep } from '@zillow/zrs-rental-applications';
import { Flex, Heading, IconFaceUnhappy, Paragraph } from '@zillow/constellation';
import { ExitReason, IdvStep } from '../../../../../models';
import { useIdVerificationCallbacks } from '../../../contexts/IdVerificationContext';

interface FrozenAccountWarningProps {
  id: string;
}

export default function FrozenAccountWarning({ id }: FrozenAccountWarningProps) {
  const { currentSubStep, onRequestStep } = useWizard();
  const { onExit } = useIdVerificationCallbacks();

  return (
    <WizardSubStep
      id={id}
      hidden={currentSubStep !== id}
      meta={{
        renderNextButton: 'Yes',
        renderBackButton: 'No',
      }}
      onRequestNext={(abortController: AbortController) => {
        abortController.abort();
        onRequestStep(IdvStep.PersonalInfoStep);
      }}
      onRequestPrev={(abortController: AbortController) => {
        abortController.abort();
        onExit({ reason: ExitReason.FrozenAccountWarning, success: false });
      }}
      render={() => (
        <Flex display="flex" flexDirection="column" gap="sm">
          <IconFaceUnhappy size="md" fontColor="blue600" />
          <Heading level={4} as="h2">
            Have you contacted Experian and unlocked your credit file?
          </Heading>
          <Paragraph>
            Our records indicate that your last attempt to verify your identity resulted in a frozen credit file
            notification from Experian. Continued attempts to verify your identity with a frozen credit file will result
            in a temporary lockout of the rental application service.
          </Paragraph>
        </Flex>
      )}
    />
  );
}
